// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M4 2.5V7.5C4 9.71 5.79 11.5 8 11.5C10.21 11.5 12 9.71 12 7.5V2.5',
  'M2.5 14H13.5',
];
